import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import ul from '../img/Certifications&Alliances/ul.png';
import retie from '../img/Certifications&Alliances/Retie.png';
import fm from '../img/Certifications&Alliances/FM.png';
import nfpa from '../img/Certifications&Alliances/nfpa.png';
import armstrong from '../img/Certifications&Alliances/armstrong.png';
import Aurora from '../img/Certifications&Alliances/Aurora.png';
import clarke from '../img/Certifications&Alliances/clarke.png';
import eaton from '../img/Certifications&Alliances/eaton.png';
import gp from '../img/Certifications&Alliances/GP.png';
import patterson from '../img/Certifications&Alliances/patterson.png';
import purity from '../img/Certifications&Alliances/purity.png';
import tornatech from '../img/Certifications&Alliances/tornatech.png';

const Certificaciones = () => {
  return (
    <>
      <Container className="my-5 text-center">
        <h3 className="mb-4">CERTIFICACIONES</h3>
        <Row className="g-4 justify-content-center">
          {[ul, retie, fm, nfpa].map((imgSrc, index) => (
            <Col key={index} xs={6} sm={4} md={3}>
              <Image src={imgSrc} alt={`cert-${index}`} className="img-logo" thumbnail />
            </Col>
          ))}
        </Row>
      </Container>

      <Container className="my-5 text-center">
        <h3 className="mb-4">ALIANZAS</h3>
        <Row className="g-4 justify-content-center">
          {[armstrong, Aurora, clarke, eaton, tornatech, patterson, purity, gp].map((imgSrc, index) => (
            <Col key={index} xs={6} sm={4} md={3}>
              <Image src={imgSrc} alt={`alianza-${index}`} className="img-logo" thumbnail />
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default Certificaciones;
